import React, {Component} from 'react'
import TableHead from "./TableHead"
import TableBody from "./TableBody"
import PropTypes from "prop-types"
import {Spin} from "antd"

class ReGenerateLabelsTable extends Component {

    render() {
        const {loading, labels, refreshList, selectAll, onCheckALl, arrSelected, onSelected, clearSelected} = this.props

        return (
            <div className="ReGenerateLabelsTable SkuTable">
                <Spin spinning={loading} tip={'Đang lấy dữ liệu...'} size='large'>
                    <table className="table table-striped">
                        <TableHead
                            selectAll={selectAll}
                            onCheckALl={onCheckALl}
                            arrSelected={arrSelected}
                            clearSelected={clearSelected}
                        />
                        <TableBody
                            labels={labels}
                            loading={loading}
                            refreshList={refreshList}
                            arrSelected={arrSelected}
                            onSelected={onSelected}
                        />
                    </table>
                </Spin>
            </div>
        )
    }
}

ReGenerateLabelsTable.propTypes = {
    refreshList: PropTypes.func.isRequired,
    labels: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    selectAll: PropTypes.bool,
    onCheckALl: PropTypes.func.isRequired,
    arrSelected: PropTypes.array,
    onSelected: PropTypes.func.isRequired,
    clearSelected: PropTypes.func.isRequired
}

export default ReGenerateLabelsTable